/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const FOCUS_BORDER_SPACING = 4;
export const CHIP_HEIGHT = 36 + FOCUS_BORDER_SPACING * 2; // Chip height + focus box-shadow spacing
export const CHIP_TOP_MARGIN = 16;
export const CHIP_BOTTOM_MARGIN = 20;
export const CHIP_COLLAPSED_FULL_HEIGHT =
  CHIP_HEIGHT + CHIP_TOP_MARGIN + CHIP_BOTTOM_MARGIN;
